import categories from './categories'
import items from './items'
import mxcategoryItems from 'vue-src/store/modules/search/mxcategory-items'
import baseSearch from './_base'

export default baseSearch({
  state: {
    filterset_name: 'basic_filter',
    _type: undefined,
  },
  modules: {
    categories,
    items,
    mxcategoryItems,
  }
})



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/store/modules/search/index.js